exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-footer[data-v-7ced3392] {\n  justify-content: center;\n}\n.modal-footer .btn[data-v-7ced3392] {\n  border-radius: 20px;\n  text-align: center;\n  border: 1px solid #01fe03;\n  background-color: #01fe03;\n  color: #000;\n  width: 200px;\n}\nb[data-v-7ced3392] {\n  font-weight: bold !important;\n}", ""]);

// exports
